import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import styles from './NavBackButton.scss';

const NavBackButton = ({ children, tag: Tag, ...rest }) => (
    <Tag {...rest} className={styles.root}>
        <span className={styles.label}>{children}</span>
    </Tag>
);

NavBackButton.propTypes = {
    children: PropTypes.any,
    tag: PropTypes.any,
};

NavBackButton.defaultProps = {
    tag: Link,
};

export default NavBackButton;
